import {
  policyManagementFetchPolicyThunk,
  policyManagementClearPolicyAction,
  policyManagementSetPolicyFineAction,
} from './policyManagementActions';
import { useAppAction, useAppSelector } from '../hooks';
import { PolicyManagementState } from './policyManagementTypes';
import { POLICY_MANAGEMENT_NAMESPACE } from './policyManagementReducer';

export function useResourceManagementSelector<
  T extends (state: PolicyManagementState) => any
>(selector: T): ReturnType<T> {
  return useAppSelector((state) =>
    selector(state[POLICY_MANAGEMENT_NAMESPACE])
  );
}

export const usePolicyManagementPolicy = () =>
  useResourceManagementSelector((state) => {
    return state.policy;
  });

export const usePolicyManagementFine = () =>
  useResourceManagementSelector((state) => {
    return state.fine;
  });

export const useFetchPolicy = () =>
  useAppAction(policyManagementFetchPolicyThunk);
export const useClearPolicyData = () =>
  useAppAction(policyManagementClearPolicyAction);
export const useSetPolicyFine = () =>
  useAppAction(policyManagementSetPolicyFineAction);
